module.exports = __webpack_public_path__ + "img/layer-group.28e27a40.svg";